var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoItemFound({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: "32px",
    viewBox: "0 0 512 512",
    width: "23px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m121.251 324.213c8.837 0 16-7.163 16-16v-257.389c0-10.379 8.444-18.824 18.823-18.824h12.947l11.591 35.675c2.142 6.592 8.285 11.056 15.217 11.056h127.843c6.932 0 13.075-4.463 15.217-11.056l11.591-35.675h12.947c7.077 0 13.504 3.959 16.774 10.332 4.032 7.862 13.679 10.966 21.539 6.931 7.862-4.034 10.966-13.677 6.932-21.54-8.774-17.1-26.111-27.723-45.245-27.723h-207.353c-28.024 0-50.823 22.799-50.823 50.824v257.389c0 8.837 7.163 16 16 16zm190.796-277.483h-104.593l-4.786-14.73h114.165zm-77.297 380.647c0-13.769 11.231-25 25-25s25 11.23 25 25-11.231 25-25 25-25-11.231-25-25zm270.313-418.191c-6.248-6.248-16.379-6.248-22.627 0l-372.493 372.494c-.003.004-.007.007-.011.011l-102.995 102.996c-6.249 6.248-6.249 16.379 0 22.627 3.124 3.124 7.218 4.686 11.313 4.686s8.189-1.563 11.313-4.687l75.688-75.688v29.55c0 28.024 22.799 50.824 50.823 50.824h207.353c28.024 0 50.823-22.8 50.823-50.824v-338.548l90.813-90.814c6.25-6.248 6.25-16.379 0-22.627zm-122.813 451.99c0 10.38-8.444 18.824-18.823 18.824h-207.353c-10.379 0-18.823-8.444-18.823-18.824v-61.55l244.999-244.999z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoItemFound);
export default __webpack_public_path__ + "static/media/no-item-found.5a817d44ccccd7ffb947442446b389b3.svg";
export { ForwardRef as ReactComponent };